import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Form, InputField } from '../form';
import { FormGroup, Button } from 'reactstrap';


// import { registrationSuccess, registrationUnload, loadApp } from '../../actions';
// import Loading from '../helpers/Loading';


import { User } from '../../api';
// import { Link } from 'react-router-dom';

const mapStateToProps = state => ({ ...state.registration });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};


class RegistrationForm extends Component {
  
  constructor (props){
    super(props);
    this.couponToggle = this.couponToggle.bind(this)
    
    this.state = {
      couponField: false,
    }
  }
  
  couponToggle (){
    this.setState({couponField: !this.state.couponField})
  }
  
  render () {
    const { joinMemberForm, initialValues, onSuccess } = this.props
    const { couponField } = this.state
    
    let ref = initialValues.ref
    
    if (!ref && localStorage.getItem('imported') === '1')
      ref = 'imported_lt'
    
    return (
        <Form
          onSubmit={User.create}
          onSuccess={onSuccess}
          initialValues={{...initialValues, ref}}
          validate={values => {
            const errors = {};
            return errors;
          }}
          render={({ handleSubmit, reset, submitting, pristine, values }) => (
        
            <form onSubmit={handleSubmit} noValidate={true}>
          
              <FormGroup>
                <InputField meta={{submitting}} name="name" type="text" placeholder="Your name" />
              </FormGroup>
            
              <FormGroup>
                <InputField meta={{submitting}} name="email" type="email" placeholder="Email" />
              </FormGroup>
            
              <FormGroup>
                <InputField meta={{submitting}} name="password" type="password" placeholder="Password" />
              </FormGroup>
            
              {false && !joinMemberForm && <FormGroup>
                { !couponField && <div className="text-center small gray pointer" onClick={this.couponToggle}>I have a coupon</div>}
                { couponField && <InputField meta={{submitting}} name="coupon_code" type="text" placeholder="Coupon Code" />}
              </FormGroup>}
            
              <FormGroup>
                <Button
                  className="upcase"
                  color="primary"
                  type="submit"
                  block
                  disabled={submitting}>
                  Sign up
                </Button>
              </FormGroup>
            
              <div className="small text-center">
                By creating an account you agree with our <a href="https://shorby.com/terms/?ref=dashboard" target="_blank" rel="noopener noreferrer">terms</a> and <a href="https://shorby.com/terms/?ref=dashboard" target="_blank" rel="noopener noreferrer">privacy policy</a>
              </div>
              { false && <pre>{JSON.stringify(values, 0, 2)}</pre> }
            </form>
          )}
        />
    )
  };
}


export default connect(mapStateToProps, matchDispatchToProps)(RegistrationForm);


// WEBPACK FOOTER //
// ./src/components/auth/RegistrationForm.js